import { FormattedMessage } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import RadioButtonMarkdown from '@shieldpay/bumblebee/markdown/radio-button.md';
import { RadioButton } from '@shieldpay/bumblebee/radio-button';
import { Text } from '@shieldpay/bumblebee/text';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { Design } from '~/components/design/design';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.radioButton.title',
});

export const RadioButtonComponentPage = () => {
  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.radioButton.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview>
        <RadioButton
          id="example1"
          name="example1"
          label="I am radio button 1, check it."
          value="radio-button-1"
        />
        <RadioButton
          id="example2"
          name="example2"
          label="I am radio button 2, check it."
          defaultChecked
          value="radio-button-2"
        />
        <RadioButton
          id="example3"
          name="example3"
          label="I am a disabled radio button."
          value="radio-button-3"
          disabled
        />
        <RadioButton
          id="example4"
          name="example4"
          label="I am a disabled, checked, radio button."
          value="radio-button-4"
          disabled
          defaultChecked
        />
      </ComponentPreview>

      <Design>
        <Design.Section heading="Usage">
          <Text paragraph>
            Only to be used when only a single option can be selected from a
            list.
          </Text>
          <Text paragraph>
            Focus state has the same 4px outline as per the buttons.
          </Text>
        </Design.Section>
      </Design>

      <MdxFormatter md={RadioButtonMarkdown} />
    </>
  );
};

export default RadioButtonComponentPage;
